import { useState, createContext, ReactNode } from 'react';

interface SidebarContextType {
  children: ReactNode;
}

interface SidebarContextValue {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
}

const initialSidebarContextValue: SidebarContextValue = {
  sidebarToggle: false,
  toggleSidebar: () => {},
  closeSidebar: () => {},
};

export const SidebarContext = createContext<SidebarContextValue>(initialSidebarContextValue);

export const SidebarProvider = (props: SidebarContextType) => {
  const { children } = props;
  const [sidebarToggle, setSidebarToggle] = useState(false);

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  const sidebarContextValue: SidebarContextValue = {
    sidebarToggle,
    toggleSidebar,
    closeSidebar,
  };

  return <SidebarContext.Provider value={sidebarContextValue}>{children}</SidebarContext.Provider>;
};
